import { Box, Button, CircularProgress } from '@mui/material';
import { BackgroundStyle, SearchingBoxContainer, LongBlueButton, HeadingTitle } from "../../assets/style";
import { userIcon } from '../../assets/imgs';
import { useEffect, useState } from "react";
import MainContent from '../../components/MainContent';
import { accountPageName } from "../../components/PageName";
import { useLazyGetAccountListQuery, useCreateAccountMutation, useUpdateAccountMutation } from "../../features/account/AccountSlice";
import RecordTableV2, { TableRow, TableHeader } from "../../components/RecordTableV2";
import { RecordModel } from "../../models/RecordModel";
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { logOut } from '../../features/auth/authSlice';
import MaintenanceRecordDetailDialog from '../../components/MaintenanceRecordDetailDialog';
import AccountModal from './AccountModal';
import { rowData } from './helpers';

const Account = () => {
    //const location = useLocation();
    //const { id, stationName } = location.state;
    const [getAccountList] = useLazyGetAccountListQuery();
    const [createAccount] = useCreateAccountMutation();
    const [updateAccount] = useUpdateAccountMutation();
    const [tableRows, setTableRows] = useState<any[]>([]);
    const [data, setData] = useState<RecordModel<any>>();
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState<number>(0);
    const [modalOpen, setModalOpen] = useState(false);
    const [isCreate, setIsCreate] = useState(false);
    const [rowData, setRowData] = useState<rowData>({
        id: '',
        name:'',
        email: '',
        roleName: '',
        companyName: '',
        phoneNumber: '',
        isActive: false,
        lastUpdatedBy: '',
        lastUpdatedAt: '',
    });
    const [isLoading, setLoading] = useState<boolean>(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {t} = useTranslation();

    const columns: TableHeader[] = [
        { field: 'name', headerName: t("Username"), width: 150, isSortable: false },
        { field: 'email', headerName: t("Email/Username"), width: 230, isSortable: false },
        { field: 'roleName', headerName: t("Role"), width: 100, isSortable: false },
        { field: 'phoneNumber', headerName: t("Phone Number"), width: 150, isSortable: false },
        { field: 'isActive', headerName: t("Active"), width: 100, isSortable: true },
        { field: 'lastUpdatedBy', headerName: t("UpdatedBy"), width: 100, isSortable: false },
        { field: 'lastUpdatedAt', headerName: t("Updated Date"), width: 200, isSortable: false },
        // {
        //     field: "Edit",
        //     headerName: t("Edit"),
        //     width: 150,
        //     renderCell: (params: any) => (
        //         <Button onClick={()=>handleEditClick(params)} > {t("Edit")} </Button>
        //     )
        // },
    ];

    const fetchDataForPage = async (pageNumber: any) => {
        // Fetch data for the specified page from the backend
        const data = await getAccountList(
            {
                page: pageNumber,
            }
        );

        if (data.status === 'fulfilled') {
            return data.data.records.map((item: any) => ({
                id: item?.id,
                name: item.name,
                email: item.email,
                roleName: item.roleName,
                companyName: item.companyName,
                phoneNumber: item.phoneNumber,
                isActive: item.isActive,
                lastUpdatedBy: item.lastUpdatedBy,
                lastUpdatedAt: new Date(item.lastUpdatedAt).toLocaleDateString('en-US'),
            }))
        }

        if (data.status === 'rejected') {
            alert(t('An error occurred. Please login again.'));
            dispatch(logOut());
            navigate('/');
        }

    };

    const handleCreateClick = () => {
       setIsCreate(true);
       setModalOpen(true);
    }

    const handleEditClick = (rowData: any) => {
        // console.log("Button clicked for row:", rowData.row);
        setRowData(rowData.row);
        setIsCreate(false);
        setModalOpen(true);
    };

    const handleCreateSubmit = async (data: {
        id: string;
        name: string;
        email: string;
        roleName: string;
        phoneNumber: string;
        isActive: boolean;
        password: string;
    }) => {
        // Handle form submission here

        const formData = {
            name:data.name,
            email:data.email,
            password:data.password,
            isActive: true,
            roleId:data.roleName === "Admin" ? 1 : 2, //Prod 1A:2U  //DEV 7A:8U
            phoneNumber:data.phoneNumber,
        }


        createAccount(formData)
            .then((respone) => {
                if ('error' in respone) {
                    //console.log(respone.error);
                    alert("StatusCode: 400")
                }
                else {
                    //console.log(respone?.data);
                    setTimeout(() => {
                        window.location.reload();
                      }, 1000);
                    alert("Update Success")
                }
            })
      };

    const handleEditSubmit = async (data: {
        id: string;
        name: string;
        email: string;
        roleName: string;
        phoneNumber: string;
        isActive: boolean;
        password: string;
    }) => {
        // Handle form submission here
        // console.log('isCreate' , isCreate);

        const formData = {
            id: data.id,
            name:data.name,
            email:data.email,
            //password:data.password,
            isActive: true,
            roleId:data.roleName === "Admin" ? 1 : 2, //Prod 1A:2U  //DEV 7A:8U
            phoneNumber:data.phoneNumber,
        }

        // console.log('test Edit',formData )
        updateAccount(formData)
            .then((respone) => {
                if ('error' in respone) {
                    //console.log(respone.error);
                    alert("StatusCode: 400")
                }
                else {
                    //console.log(respone?.data);
                    setTimeout(() => {
                        window.location.reload();
                      }, 1000);
                    alert("Update Success")
                }
            })
      };


    useEffect(() => {
        try {
            setLoading(true);
            getAccountList({
                page: 1,
            }).then(
                (res) => {
                    if (res.status === 'fulfilled') {
                        setLoading(false);
                        const tableRows = res?.data.records.map((item: any) => ({
                            id: item?.id,
                            name: item.name,
                            email: item.email,
                            roleName: item.roleName,
                            companyName: item.companyName,
                            phoneNumber: item.phoneNumber,
                            isActive: item.isActive,
                            lastUpdatedBy: item.lastUpdatedBy,
                            lastUpdatedAt: new Date(item.lastUpdatedAt).toLocaleDateString('en-US'),
                        }))
                        setTableRows(tableRows)
                        setData(res?.data)
                    }

                    if (res.status === 'rejected') {
                        setLoading(false);
                        alert(t('An error occurred. Please login again.'));
                        dispatch(logOut());
                        navigate('/');
                    }
                }
            )
        } catch (error) {

        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps


    const handleRowClick = (row : any) => {
        setSelectedRecord(row.id)
        setOpenDialog(true);
    };

    return (
        <MainContent type={accountPageName}>
            <Box sx={{ bgcolor: '#456296' }}>
                <HeadingTitle>{t("User Management")}</HeadingTitle>
            </Box>
            <BackgroundStyle sx={{ zIndex: 0 }}>
                <AccountModal
                    isCreate={isCreate}
                    rowData={rowData}
                    open={modalOpen}
                    onClose={() => setModalOpen(false)}
                    onSubmit={isCreate? handleCreateSubmit : handleEditSubmit }
                />
                    <SearchingBoxContainer>
                    </SearchingBoxContainer>
                    <LongBlueButton onClick={handleCreateClick}>{t("Create")}</LongBlueButton>
                {isLoading && <Box sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: 300
                }}>
                    <CircularProgress size={60} />
                </Box>}
                {!isLoading && <RecordTableV2
                    columns={columns}
                    rows={tableRows}
                    checkbox={false}
                    pages={data?.totalPages}
                    totalCount={data?.totalCount}
                    onClick={handleRowClick}
                    updateTableRows={setTableRows}
                    fetchDataForPage={fetchDataForPage}
                ></RecordTableV2>
                }
            </BackgroundStyle>
        </MainContent >
    );
};
export default Account;